/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_FeedbackInputs */

const es_sidebar_feedback = /** @type {(inputs: Sidebar_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar feedback`)
};

const en_sidebar_feedback = /** @type {(inputs: Sidebar_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send feedback`)
};

/**
* | output |
* | --- |
* | "Send feedback" |
*
* @param {Sidebar_FeedbackInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_feedback = /** @type {((inputs?: Sidebar_FeedbackInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_FeedbackInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_feedback(inputs)
	return en_sidebar_feedback(inputs)
});
export { sidebar_feedback as "sidebar.feedback" }